import React from "react";
import { hasStyleChanges } from "../utils.js";
import styles from "./CustomHeadingButton-scss.js";
const headingsMap = {
  "header-one": "Heading 1",
  "header-two": "Heading 2",
  "header-three": "Heading 3",
  "header-four": "Heading 4",
  "header-five": "Heading 5",
  "header-six": "Heading 6",
  unstyled: "P"
};
const findOsName = () => {
  if (navigator.userAgent.indexOf("Win") !== -1) return "Windows";
  if (navigator.userAgent.indexOf("Mac") !== -1) return "MacOS";
  return null;
};
const headingShortcuts = {
  MacOS: (number) => ` (⌘⌥${number})`,
  Windows: (number) => ` (Ctrl+Alt+${number})`
};
const translateHeading = (option = "P", t, shouldAddShortcut = false) => {
  const number = parseInt(option.slice(-1)) ? option.slice(-1) : void 0;
  const osName = findOsName();
  const shortcut = shouldAddShortcut && osName ? headingShortcuts[osName](number || 0) : void 0;
  return option === "P" ? t("FormattingToolbar_TextStyle_Paragraph", shortcut && { shortcut }) : t("FormattingToolbar_TextStyle_Heading", shortcut ? { number, shortcut } : { number });
};
const getCustomHeadingsLabel = (selectedHeading, t, publicCommands) => {
  let label = translateHeading(headingsMap[selectedHeading], t);
  const inlineStyles = publicCommands.getInlineStylesInSelection() || {};
  if (hasStyleChanges(selectedHeading, inlineStyles, publicCommands.getDocumentStyle())) {
    label = /* @__PURE__ */ React.createElement(React.Fragment, null, label, /* @__PURE__ */ React.createElement("span", { className: styles.toolbarLabelUpdate }, "*"));
  }
  return label;
};
export {
  getCustomHeadingsLabel,
  headingsMap,
  translateHeading
};
//# sourceMappingURL=utils.js.map
